import { MeterBarToolbarSlotProps } from '../types/meter-bar-toolbar.js';

export const Toolbar = (props: MeterBarToolbarSlotProps) => null;

Toolbar['displayName'] = 'MeterBarChart.Toolbar';
